import { createFileRoute } from '@tanstack/react-router'
import { ReceiptText } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { EmptyState } from '@/shared/ui/empty-state'
import { PageHeader } from '@/widgets/app-shell/page-header'

export const Route = createFileRoute('/_authed/configuracoes/nfse')({
  component: Page,
})

function Page() {
  const { t } = useTranslation(['nav', 'common'])
  const titulo = t('nav:settings.nfse')

  return (
    <>
      <PageHeader title={titulo} />
      <EmptyState icon={ReceiptText} title={titulo} description={t('common:states.empty')} />
    </>
  )
}
